/**
 * Círculos de colecciones — control de carrusel con flechas.
 * Soporta múltiples instancias de la sección en la misma página.
 */
function initCirculosCarrusel(sectionId) {
  var container = document.getElementById('circulos-' + sectionId);
  if (!container) return;

  var track = container.querySelector('#circulos-track-' + sectionId);
  var prevBtn = container.querySelector('.circulos-nav-prev');
  var nextBtn = container.querySelector('.circulos-nav-next');

  if (!track || !prevBtn || !nextBtn || track.dataset.circulosInit === 'true') {
    return;
  }
  track.dataset.circulosInit = 'true';

  function getScrollAmount() {
    var item = track.querySelector('.circulos-coleccion-item');
    if (!item) return track.clientWidth;
    var gap = parseFloat(getComputedStyle(track).gap) || 0;
    // Avanza de a 2 círculos por click para que se note el movimiento,
    // pero nunca más de lo que cabe visible.
    var itemWidth = item.getBoundingClientRect().width + gap;
    var visible = Math.max(1, Math.floor(track.clientWidth / itemWidth));
    var step = Math.max(1, Math.floor(visible / 2));
    return itemWidth * step;
  }

  function updateButtonsState() {
    var maxScroll = track.scrollWidth - track.clientWidth - 1;
    prevBtn.disabled = track.scrollLeft <= 0;
    nextBtn.disabled = track.scrollLeft >= maxScroll;
  }

  prevBtn.addEventListener('click', function () {
    track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
  });

  nextBtn.addEventListener('click', function () {
    track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
  });

  track.addEventListener('scroll', function () {
    window.requestAnimationFrame(updateButtonsState);
  });

  window.addEventListener('resize', updateButtonsState);

  // Estado inicial
  updateButtonsState();
}
